// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import t from 'tcomb';

const ClaimValueSummary = t.struct({
    creditMemoNumber: t.String,
    currency: KeyValuePair,
    netAmount: t.maybe(t.Number),
    recoverPercentage: t.maybe(t.Number),
    reimbursedAmount: t.maybe(t.Number)
}, {
    name: 'ClaimValueSummary',
    strict: true
});

export const getDefaultState = () => new ClaimValueSummary({
    creditMemoNumber: '',
    currency: getKeyValueDefaultState(),
    netAmount: null,
    recoverPercentage: null,
    reimbursedAmount: null
});

export default ClaimValueSummary;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-value-summary.js